import request from '../../../../static/scripts/common/request_fn';
import {idUtil, storeUtil} from '../../../../static/scripts/util';
import {
  getMockTopologyNodeExtendInfoById,
  getMockTpShapeAttrById,
  listMockJobDetailById,
  listMockLineDetailById,
  listMockTopologyDataByTpId,
  listMockTpElementData,
  listMockTpJobByIdentity,
  listMockTpShapeList
} from './mock';

/**
 * 拓扑插件-接口数据定义
 */

/**
 * 业务表格参数
 */
export const tableParams = {
  // 进度条高度
  strokeWidth: 10,
  tooltipDisabled: false,
  tableData: [],

  background: true,
  tablePageNum: 1,
  tablePageSize: 20,
  tableTotalCount: 0,
  tablePageSizes: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 200],
  tablePagingLayout: 'prev, pager, next, total, sizes, jumper',
  hideOnSinglePage: true
};


/**
 * 拓扑插件-根据元素ID获取图形对应属性
 * 内置图形不走接口
 *
 * @param elementId 元素ID
 * @returns result 数据Promise结果
 */
export function getTpShapeAttrById(elementId) {
  return getMockTpShapeAttrById(elementId);
}


/**
 * 拓扑插件-获取一个图形ID
 */
export function getIdStr() {
  const idArray = storeUtil.getStore('tp:element:id:array') || [];
  if (idArray.length > 0) {
    const id = idArray.shift();
    // 每次获取ID都需要验证是否再次获取ID
    listElementIdArray(idArray);
    storeUtil.setStore('tp:element:id:array', idArray);
    return id;
  }
  return idUtil.getIdStr();
}


/**
 * 拓扑插件-生成一批图形ID并缓存
 * @param idArray 图形ID集合
 */
export function listElementIdArray(idArray) {
  idArray = idArray || [];
  if (!idArray || idArray.length < 5) {
    if (getMockStatus()) {
      for (let i = 0; i < 20; i++) {
        idArray.push(idUtil.getIdStr());
      }
      storeUtil.setStore('tp:element:id:array', idArray);
    } else {
      listGenerateId().then(resp => {
        if (resp.data) {
          idArray.push(...resp.data);
          storeUtil.setStore('tp:element:id:array', idArray);
        }
      });
    }
  }
}


/**
 * 拓扑插件-生成ID-生成一批（50个）分布式ID
 * @returns result 生成的ID数据
 */
export function listGenerateId() {
  const url = '/tp/topology/api/data/id';
  return request.get(url).then(resp => resp.data);
}


/**
 * 拓扑插件-获取拓扑插件左侧边栏模块列表
 * @returns result 数据Promise结果
 */
export function listTpElementData(params) {
  if (getMockStatus()) {
    return listMockTpElementData();
  }

  const url = '/tp/topology/api/data/element';
  return request.get(url, {params: params}).then(resp => resp.data);
}


/**
 * 拓扑插件-根据图形元素标识获取监视器列表
 * @param params 查询条件
 * @returns promise 监视器列表Promise
 */
export function listTpJobByIdentity(params) {
  if (getMockStatus()) {
    return listMockTpJobByIdentity(params);
  }

  const url = '/tp/topology/api/data/node/job';
  return request.get(url, {params: params}).then(resp => resp.data);
}


/**
 * 拓扑插件-根据监视器节点ID获取节点扩展信息
 * @param nodeId 节点ID
 * @returns promise 节点扩展信息Promise
 */
export function getTopologyNodeExtendInfoById(nodeId) {
  if (getMockStatus()) {
    return getMockTopologyNodeExtendInfoById(nodeId);
  }

  const url = '/tp/topology/api/data/node/extend/' + nodeId;
  return request.get(url).then(resp => resp.data);
}


/**
 * 拓扑插件-根据监视器ID获取监视器详情
 * @param jobId 监视器ID
 * @returns promise 监视器详情 Promise
 */
export function listJobDetailById(jobId) {
  if (getMockStatus()) {
    return listMockJobDetailById(jobId);
  }
  const url = '/tp/topology/api/data/node/job/detail/' + jobId;
  return request.get(url).then(resp => resp.data);
}


/**
 * 拓扑插件-根据边ID获取连线详情
 * @param edgeId 边ID
 * @returns promise 边详情 Promise
 */
export function listLineDetailById(edgeId) {
  if (getMockStatus()) {
    return listMockLineDetailById(edgeId);
  }
  const url = '/tp/topology/api/data/node/line/detail/' + edgeId;
  return request.get(url).then(resp => resp.data);
}


/**
 * 拓扑插件-保存拓扑图表单数据
 * @param formData 表单信息
 * @returns result 保存拓扑图结果
 */
export function saveTopologyAllGraphData(formData) {
  const url = '/tp/topology/api/data';
  return request.post(url, formData).then(resp => resp.data);
}


/**
 * 拓扑插件-根据拓扑ID获取拓扑图所有节点、边和Combo
 * @param tpId 拓扑ID
 * @returns result 拓扑图数据
 */
export function listTopologyDataByTpId(tpId) {
  if (getMockStatus()) {
    return listMockTopologyDataByTpId(tpId);
  }
  const url = '/tp/topology/api/data/' + tpId;
  return request.get(url).then(resp => resp.data);
}





/**
 * 拓扑插件-获取拓扑图分页数据列表
 * @param params 查询条件
 * @returns result 拓扑图分页数据列表
 */
export function listTopologyGraphByPage(params) {
  const url = '/tp/topology-graph/data';
  return request.get(url, {params}).then(resp => resp.data);
}


/**
 * 拓扑插件-保存拓扑所有图形数据
 * @param formData 表单信息
 */
export function saveTopologyGraphData(formData) {
  const url = '/tp/topology-graph/data';
  return request.post(url, formData).then(resp => resp.data);
}

/**
 * 拓扑插件-更新拓扑图表单数据
 * @param formData 表单信息
 */
export function updateTopologyGraphData(formData) {
  const url = '/tp/topology-graph/data';
  return request.put(url, formData).then(resp => resp.data);
}


/**
 * 拓扑插件-删除拓扑图指定 ID 数据
 * @param id 要删除的数据 ID
 */
export function deleteTopologyGraphData(id) {
  const url = '/tp/topology-graph/data/' + id;
  return request.delete(url).then(resp => resp.data);
}






/**
 * 拓扑插件-获取拓扑选择器组件内置图形数据列表
 */
export function listTpShapeList() {
  if (getMockStatus()) {
    return listMockTpShapeList();
  }

  const url = '/tp/topology/api/node/attr/selector/shape/data';
  return request.get(url).then(resp => resp.data);
}











/**
 * 根据监视器ID获取监视器端口列表
 * @param jobId 监视器ID
 * @returns promise 监视器端口列表 Promise
 */
export function listJobPortById(jobId) {
  const url = '/tp/topology/api/node/job/port/' + jobId;
  return request.get(url).then(resp => resp.data);
}














/**
 * 拓扑插件-获取Mock状态（mock模式使用静态数据，非mock模式调用接口）
 * @returns true mock模式，false 非mock模式
 */
export function getMockStatus() {
  return true;
}
